import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trix-disable-attachment"
export default class extends Controller {
	initialize() {
		this.toolbarElement = this.element.toolbarElement
	}

	connect() {
		// Removing file attachment button
		this.removeButtons()
		// Prevents file uploads
		this.eventListenerForFileAccept()
	}

	removeButtons() {
		const file_tools = this.toolbarElement.querySelector("[data-trix-button-group='file-tools']");
		file_tools.remove();
	}

	eventListenerForFileAccept() {
		document.addEventListener("trix-file-accept", function (e) {
			e.preventDefault();
		})
	}
}